import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from '@/store';
import PageLoader from '../page-loader';

export type FixedFullBleedPageProps = {
  children: React.ReactNode;
};

/**
 * Full-bleed sibling of `FixedConfigPage`.
 *
 * Some hand-written nova areas are standalone experiences that own the
 * WHOLE viewport and bring their own chrome (header / footer / sidebar) — e.g.
 * the `configurator-v3` wizard. They must NOT be wrapped in the config-driven
 * account layout (left menu / top bar / Lumio panel), so this bridge keeps only
 * the auth gate and renders the route element directly, edge-to-edge.
 */
export const FixedFullBleedPage = ({ children }: FixedFullBleedPageProps): React.ReactElement => {
  const authenticated = useAppSelector((state) => state.authentication && state.authentication.auth_type === 'user');
  const isAuthInProgress = useAppSelector((state) => state.authentication.in_progress);

  if (!authenticated) {
    if (isAuthInProgress) return <PageLoader />;
    return <Navigate to="/login" replace />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default FixedFullBleedPage;
